var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"outline-warning"},on:{"click":_vm.marcarAvistamento}},[_c('i',{staticClass:"fa fa-binoculars"}),_vm._v(" Marcar Avistamento ")])
}
var staticRenderFns = []

export { render, staticRenderFns }